import { render, staticRenderFns } from "./RegisterJWT.vue?vue&type=template&id=4a6c7a5a"
import script from "./RegisterJWT.vue?vue&type=script&lang=js"
export * from "./RegisterJWT.vue?vue&type=script&lang=js"
import style0 from "./RegisterJWT.vue?vue&type=style&index=0&id=4a6c7a5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports